
/** DO NOT EDIT: This file is automatically generated by ../scripts/info.js */
export const LIB_VERSION = '2.10.1';
export const LIB_NAME = '@clerk/clerk-react';
